import cx from "classnames";
import styles from "../styles/optionsPanel.module.sass";
import { singleCasementOptions } from "../utils/optionsMenuData";
import ImagineToggle from "./toggle";

function Section({ title, content, activeItem, setActiveItem }) {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.sectionContent}>
        {content.map((option) => (
          <div
            key={option.name}
            className={cx(styles.sectionItem, {
              [styles.sectionItemActive]: activeItem === option.id,
            })}
            onClick={() => setActiveItem(option.id)}
          >
            <div
              className={styles.sectionItemColor}
              style={{ backgroundColor: option.color }}
            />
            <div className={styles.sectionItemName}>{option.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function OptionsPanel({
  windowOpen,
  setWindowOpen,
  dayNightCycle,
  setDayNightCycle,
  interiorExterior,
  setInteriorExterior,
  activeConfig,
  setActiveConfig,
  activeHinge,
  setActiveHinge,
  activeBugscreen,
  setActiveBugscreen,
  activeBlind,
  setActiveBlind,
  activeBlindDirection,
  setActiveBlindDirection,
  activePaintColor,
  setActivePaintColor,
  activePaintedSide,
  setActivePaintedSide,
  activePremiumCenterLock,
  setActivePremiumCenterLock,
  activeHardware,
  setActiveHardware,
  activeFrostedGlass,
  setActiveFrostedGlass,
  activeGrillStyle,
  setActiveGrillStyle,
  activeGrillPattern,
  setActiveGrillPattern,
  activeSDLStyle,
  setActiveSDLStyle,
  activeSDLPattern,
  setActiveSDLPattern,
  activeExtraScreenBlindCartridge,
  setActiveExtraScreenBlindCartridge,
  activeLimiter,
  setActiveLimiter,
  activeNightLock,
  setActiveNightLock,
}) {
  return (
    <div className={styles.optionPanel}>
      <ImagineToggle label={"Open window"} setItem={setWindowOpen} />
      <ImagineToggle label={"Day / Night"} setItem={setDayNightCycle} />
      {/* <ImagineToggle label={"Interior / Exterior"} setItem={setInteriorExterior} /> */}
      {/* <Section
        title="Configuration"
        content={singleCasementOptions.configuration}
        activeItem={activeConfig}
        setActiveItem={setActiveConfig}
      /> */}
      {/* <Section
        title="Hinge / Operator"
        content={singleCasementOptions.hinge}
        activeItem={activeHinge}
        setActiveItem={setActiveHinge}
      /> */}
      {/* <Section
        title="Bug screens"
        content={singleCasementOptions.bugscreen}
        activeItem={activeBugscreen}
        setActiveItem={setActiveBugscreen}
      /> */}
      <Section
        title="Shade / Blind"
        content={singleCasementOptions.blind}
        activeItem={activeBlind}
        setActiveItem={setActiveBlind}
      />
      {/* <Section
        title="Blinds direction"
        content={singleCasementOptions.blindDrirection}
        activeItem={activeBlindDirection}
        setActiveItem={setActiveBlindDirection}
      /> */}
      <Section
        title="Paint Color"
        content={singleCasementOptions.paintColor}
        activeItem={activePaintColor}
        setActiveItem={setActivePaintColor}
      />
      {/* <Section
        title="Painted Side"
        content={singleCasementOptions.paintedSide}
        activeItem={activePaintedSide}
        setActiveItem={setActivePaintedSide}
      /> */}
      <Section
        title="Premium Center Lock"
        content={singleCasementOptions.premiumCenterLock}
        activeItem={activePremiumCenterLock}
        setActiveItem={setActivePremiumCenterLock}
      />
      <Section
        title="Hardware"
        content={singleCasementOptions.hardware}
        activeItem={activeHardware}
        setActiveItem={setActiveHardware}
      />
      {/* <Section
        title="FrostedGlass"
        content={singleCasementOptions.frostedGlass}
        activeItem={activeFrostedGlass}
        setActiveItem={setActiveFrostedGlass}
      /> */}
      {/* <Section
        title="Grill Style"
        content={singleCasementOptions.grillStyle}
        activeItem={activeGrillStyle}
        setActiveItem={setActiveGrillStyle}
      /> */}
      <Section
        title="Grill Pattern"
        content={singleCasementOptions.grillPatern}
        activeItem={activeGrillPattern}
        setActiveItem={setActiveGrillPattern}
      />
      {/* <Section
        title="SDL Style"
        content={singleCasementOptions.SDLStyle}
        activeItem={activeSDLStyle}
        setActiveItem={setActiveSDLStyle}
      /> */}
      <Section
        title="SDL Pattern"
        content={singleCasementOptions.SDLPatern}
        activeItem={activeSDLPattern}
        setActiveItem={setActiveSDLPattern}
      />
      {/* <Section
        title="Extra Screen / Blind Cartridge"
        content={singleCasementOptions.extraScreenBlindCartirdge}
        activeItem={activeExtraScreenBlindCartridge}
        setActiveItem={setActiveExtraScreenBlindCartridge}
      /> */}
      {/* <Section
        title="Limiter"
        content={singleCasementOptions.limiter}
        activeItem={activeLimiter}
        setActiveItem={setActiveLimiter}
      /> */}
      {/* <Section
        title="Night Lock"
        content={singleCasementOptions.nightLock}
        activeItem={activeNightLock}
        setActiveItem={setActiveNightLock}
      /> */}
    </div>
  );
}
